module.exports = __webpack_public_path__ + "static/media/certificate-path-active.61911c42.svg";